<div class="photo-video-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Photo & Video Requirements</h3>
      </div> -->

      <nz-form-item>
        <nz-form-label nzRequired>No. of Videographers</nz-form-label>
        <nz-form-control>
          <input nz-input type="text" formControlName="video_description" placeholder="Enter no. of videographers" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>No. of Photographers</nz-form-label>
        <nz-form-control>
          <input nz-input type="text" formControlName="photo_description" placeholder="Enter no. of photographers" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>